/*!
 * Copyright (c) 2024 Gateway Forge LLC.
 * All rights reserved.
 *
 * This software and its source code are proprietary and confidential to Gateway Forge LLC.
 * Unauthorized copying, distribution, or modification is prohibited.
 */

import React from 'react'
import { useGlobal } from '../../utility/CTX'
import { Column } from '../../layout/components/dom';

function PostsList() {
    const { theme } = useGlobal();

    return <Column style={{margin: 10, borderRadius: 5, background: theme.bg2, padding: 5, minHeight: 150, maxHeight: 150, maxWidth: 800, width: '100%'}}>
        <b style={{margin: '0px 5px'}}>Results</b>
    
    </Column>
}

export default PostsList